/**
 * AWS Amplify Configuration
 *
 * Configures AWS Amplify with Cognito User Pool settings for authentication.
 * This configuration is imported early in the application lifecycle to ensure
 * all Amplify services are properly initialized.
 */

import { Amplify } from 'aws-amplify';

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
const userPoolClientId = process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '';

// AWS Cognito configuration object - Amplify v6 format
const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId, // Cognito User Pool ID (e.g. us-east-1_xxxxxxxx)
      userPoolClientId, // App Client ID
      loginWith: {
        email: true,
      }
    }
  }
};

// Configure Amplify with the above settings
if (!userPoolId || !userPoolClientId) {
  console.error('❌ [AWS Config] Missing Cognito env vars. Set REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_USER_POOL_CLIENT_ID.');
}
console.log('🔧 [AWS Config] Configuring Amplify with User Pool:', awsconfig.Auth.Cognito.userPoolId || '(missing)');
Amplify.configure(awsconfig);
console.log('✅ [AWS Config] Amplify configuration complete');

export default awsconfig;